/**
 * Converts text to title case where the first letter of each word is capitalized
 * @param text The input text to convert
 * @returns The text in title case
 */
const toTitleCase = (text: string): string => {
  if (!text) return '';
  
  // List of words that should remain lowercase unless they are the first word
  const lowercaseWords = [
    'a', 'an', 'the', 'and', 'but', 'or', 'for', 'nor', 'on', 'at', 'to', 'from', 'by', 'in', 'of', 'with'
  ];
  
  return text
    .toLowerCase()
    .split(' ')
    .map((word, index) => {
      // Skip empty strings from multiple spaces
      if (!word) return '';
      
      // Always capitalize the first word, or any word that's not in our lowercase list
      if (index === 0 || !lowercaseWords.includes(word)) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      return word;
    })
    .join(' ');
};

/**
 * Simple title case function that can be used for basic strings
 * For React components, use the TitleCase component instead
 */
export { toTitleCase };

// Note: The titleCaseNode function has been removed as it was causing TypeScript issues.
// Please use the TitleCase component for React components instead.
